import React from 'react';

import * as S from './styled';

const BookmarkIconNotSaved = () => (
  <S.IconStyledNotBookmarked icon="bookmark-ghost" size="24" />
);

const BookmarkIconSaved = () => (
  <S.IconStyledBookmarked icon="bookmark" size="24" />
);

export const getBookmarkIcon = (isBookmarked) => {
  if (isBookmarked) return <BookmarkIconSaved />;
  return <BookmarkIconNotSaved />;
};
